import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// import { Application } from '../../models/application';
import { ApplicantBasic } from '../../models/applicantbasic';
import { MoveInReason } from '../../models/moveinreason';
import { LeasingAgent } from '../../models/leasingagent';
import { ApplicationDataService } from '../../../services/application.service';
import { ApplicationComponent } from '../application.component';
import { CognitoUtil } from 'services/cognito.service';
import { Property } from '../../models/property';
import { TelephoneNumber } from 'app/models/telephone-number';
import { EventEmitterService } from 'services/event-emitter.service';
import { SplashService } from 'services/splash.service';
import { LabelValue } from '../../models/labelvalue';
import { TrackingParameters } from 'app/models/tracking-parameter';
import { RentalRates } from 'app/models/rental-rates';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PricingCalendarComponent } from './pricing-calendar/pricing-calendar.component';
import { ErrorService } from '../../../services/error.service';
import { RentablesDataService } from 'services/rentables.service';
import { RentalRatesDay } from 'app/models/rental-rates-day';
import { AnalyticsService } from 'services/analytics.service';
import { AdditionalApplicationStepsInterface } from 'app/interface/additionalApplicationStepsInterface';
import { filter, finalize, map, mergeMap, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-basic',
  templateUrl: './basic.component.html',
  styleUrls: ['./basic.component.css']
})
export class BasicComponent implements OnInit {
  private sub: any;
  errorMessage: string = null;
  model: ApplicantBasic;
  days: [];
  years: [];
  moveReasons: LabelValue[];
  modelProperty: Property;
  properties: string[] = [];
  results: string[];
  selectedProperty: string;
  leasingAgentOptions: LabelValue[];
  leaseTermOptions: LabelValue[] = [];
  hasExternalAgentOptions: LabelValue[];
  hasReferralOptions: LabelValue[];
  smartHomeInterestOptions: LabelValue[];
  maxMoveInDate: Date = new Date();
  minMoveInDate: Date = new Date();
  AddAdditionalApplicantKey: number = null;
  AddAdditionalApplicantName: string = null;
  homePhoneNumber: TelephoneNumber = null;
  cellPhoneNumber: TelephoneNumber = null;
  splashHTML: string;
  email: string;
  providerType: string;
  trackingParams: TrackingParameters;
  rentalRates: RentalRates = new RentalRates();
  displayedRentRate: number = null;
  desiredMoveInDate: Date = null;
  desiredLeaseTerm: number = null;
  isSFRC: Boolean = false;
  variablePricingAvailable: Boolean = false;
  isLoading: Boolean = true;
  displayedRentRateOrRange: string;
  hasRentableItems: boolean;
  totalApplicationSteps: number = 8;
  disableSubmitBtn: Boolean = false;
  yardiKey: string = null;

  constructor(
    private applicationService: ApplicationDataService,
    public router: Router,
    public route: ActivatedRoute,
    private rentablesService: RentablesDataService,
    private app: ApplicationComponent,
    private cognitoUtil: CognitoUtil,
    private eventEmitterService: EventEmitterService,
    private splashService: SplashService,
    public dialog: MatDialog,
    private errorService: ErrorService,
    private readonly analyticsService: AnalyticsService) {
    this.model = new ApplicantBasic();
    this.analyticsService.track(
      'HRA Application',
      'Basic Information',
      'Start',
      'Start',
      '',
      this.additionalAnalyticsDetails());

    const addAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');

    if (addAdditionalApplicantKey !== null && addAdditionalApplicantKey !== undefined) {
      this.AddAdditionalApplicantKey = Number(addAdditionalApplicantKey);
    }

    const rentalApplicationKey = localStorage.getItem('RentalApplicationKey');
    const rentalApplicantKey = localStorage.getItem('RentalApplicantKey');
    const yardiKey = localStorage.getItem('YardiKey');
    this.yardiKey = yardiKey;
    const desiredMID = localStorage.getItem('DesiredMoveInDate');
    const desiredLT = localStorage.getItem('DesiredLeaseTerm');

    try {
      if (desiredMID && desiredMID.match(/^\d{4}\-\d{2}\-\d{2}$/)) { // If the format looks to match YYYY-MM-DD.
        const parsedMid = desiredMID.split('-');
        this.desiredMoveInDate = new Date(
          parseInt(parsedMid[0]), // Year.
          parseInt(parsedMid[1]) - 1, // Month (uses a 0 offset for some reason).
          parseInt(parsedMid[2])); // Day.
      } else if (desiredMID && desiredMID.match(/^\d{2}\-\d{2}\-\d{4}$/)) { // If the format looks to match MM-DD-YYYY.
        const parsedMid = desiredMID.split('-');
        this.desiredMoveInDate = new Date(
          parseInt(parsedMid[2]), // Year.
          parseInt(parsedMid[0]) - 1, // Month (uses a 0 offset for some reason).
          parseInt(parsedMid[1])); // Day.
      } else if (desiredMID) { // If not in an accounted for format.
        this.desiredMoveInDate = new Date(desiredMID);
      }
    } catch (error) {
      console.error(error);
    }

    if (desiredLT) {
      this.desiredLeaseTerm = Number(desiredLT);
    }

    this.email = localStorage.getItem("Email");
    this.providerType = localStorage.getItem("ProviderType");

    this.minMoveInDate.setHours(0, 0, 0, 0);
    this.maxMoveInDate.setHours(0, 0, 0, 0);
    this.maxMoveInDate.setDate(this.maxMoveInDate.getDate() + 21);

    if (rentalApplicationKey !== undefined && rentalApplicationKey !== null &&
      rentalApplicantKey !== undefined && rentalApplicantKey !== null) {

      this.model.RentalApplicationKey = Number(rentalApplicationKey);
      this.model.RentalApplicantKey = Number(rentalApplicantKey);

      this.eventEmitterService.splashChangeEmitted$.subscribe(res => this.updateSplashHTML(res));

      this.splashService.updateSplash("apply");
    } else {
      this.analyticsService.track(
        'HRA Application',
        'Basic Information',
        'Stop',
        'No rentail application key',
        '/application/landing',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/landing']);
    }
  }

  private additionalAnalyticsDetails(): any {
    try {
      return {
        'MoveInDate': this.model?.DesiredMoveInDate,
        'LeaseTerm': this.model?.LeaseTerm,
        'LeaseTermOptions': this.leaseTermOptions,
        'HasExternalAgent': this.model?.HasExternalAgent,
        'ExternalAgentName': this.model?.ExternalAgentName,
        'HasReferrals': this.model?.hasReferrals,
        'ReferralName': this.model?.ReferralName
      };
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  ngOnInit() {
    this.rentablesService.GetPropertyHasRentableItems(this.model.RentalApplicationKey.toString(), this.yardiKey).subscribe(res => this.setRentableItemsFlag(res, true));
  }

  continueLoading() {
    this.initializeApplicationAsync(this.yardiKey, this.model.RentalApplicationKey, this.model.RentalApplicantKey, this.AddAdditionalApplicantKey)
    this.applicationService.getReferralProperties().subscribe(res => this.onGetProperties(res), err => this.applicationService.handleError(err));
    this.applicationService.getRentalMoveInReasons().subscribe(res => this.getMoveReasons(res),res => this.applicationService.handleError(res));

    this.applicationService.getLeasingAgentOptions(this.model.RentalApplicationKey).subscribe(res => this.getLeasingAgentOptions(res),res => this.errorMessage = this.applicationService.handleError(res));

    this.getHasReferralOptions();
    this.getHasExternalAgentOptions();
    this.getSmartHomeInterestOptions();

    if (this.providerType !== null) {
      if (this.email != null) {
        this.model.Email = this.email;
      }
    } else {
      this.model.Email = this.cognitoUtil.getCurrentUser().getUsername();
    }

    const property = JSON.parse(localStorage.getItem('SelectedProperty'));

    if (property != null) {
      this.modelProperty = property[0];
      this.onUpdateRentRateOrRange();
    }
  }

  initializeApplicationAsync = async (yardiKey, rentalApplicationKey, rentalApplicantKey, addAdditionalApplicantKey) => {
    try {
      this.isSFRC = await this.applicationService.checkPropertyForSFRC(yardiKey).toPromise();

      this.applicationService.getBasicInformation(rentalApplicationKey, rentalApplicantKey, addAdditionalApplicantKey)
        .subscribe(res => this.getBasicInfo(res), res => this.errorMessage = this.applicationService.handleError(res));

      this.applicationService.checkIsPrimary(this.model.RentalApplicationKey)
        .subscribe(res => this.setPrimaryFlag(res), err => this.errorMessage = this.applicationService.handleError(err));

      this.applicationService.checkIsCorrectStatus(this.model.RentalApplicationKey)
        .subscribe(res => this.setCorrectStatusFlag(res), err => this.errorMessage = this.applicationService.handleError(err));

      this.applicationService.getProperty(localStorage.getItem('YardiKey'))
        .subscribe(res => this.setProperty(res.results));

      this.onUpdateRentRateOrRange();
    } catch(error) {
      console.error(error);

      this.errorService.showError("Error Initializing Application Information");
    }
  }

  checkforVariablePricing(yardiKey): void {
    this.isLoading = true;

    this.checkForRentalRates(yardiKey);

    this.isLoading = false;
  }

  getLeaseTermOptions(){
    if(this.rentalRates.LeaseTermOptions.length===0) {
      let leaseTermOpt=this.applicationService.getLeaseTermOptions(this.model.RentalApplicationKey, this.model.DesiredMoveInDate)
      leaseTermOpt.subscribe(res => {
          this.setLeaseTermOptions(res, this.desiredLeaseTerm)
      },
      res => this.errorMessage = this.applicationService.handleError(res))    
    }
  }

  checkForRentalRates(yardiKey) {
    let rates=this.applicationService.getRentalRatesSF(yardiKey)
      rates.pipe(finalize(()=>{
        if(this.rentalRates.LeaseTermOptions.length===0)
          this.errorService.showError(`No rental rates found for the selected property.`);
      }))
      .subscribe(res => {
        // convert best date to browser's TZ
        res.BestLeaseTermDate = new Date(res.BestLeaseTermDate.getUTCFullYear(), res.BestLeaseTermDate.getUTCMonth(), res.BestLeaseTermDate.getUTCDate());

        this.processRentalRates(res);
      },_=>this.isLoading=false);
  }

  dateFilter = (d: any) => {

    let date = new Date(d);

    if (this.rentalRates.DayTermOptionsMap.size !== 0) {
      return this.rentalRates.DayTermOptionsMap.has(`${date.getUTCFullYear()}-${date.getUTCMonth()}-${date.getUTCDate()}`);
    }
    else {
      return true;
    }
  };

  updateSplashHTML(res: string) {
    this.splashHTML = res;
  }

  setProperty(property: Property[]) {
    this.modelProperty = property[0];
    if ((property[0].min_rent != null && property[0].max_rent != null) && (property[0].min_rent == property[0].max_rent)) {
      this.modelProperty.rent = property[0].min_rent.toLocaleString();
    }
    else if (property[0].min_rent != null && property[0].max_rent != null) {
      this.modelProperty.rent = property[0].min_rent.toLocaleString() + '-$' + property[0].max_rent.toLocaleString()
    }
    this.onUpdateRentRateOrRange();
  }

  setRentableItemsFlag = (res: AdditionalApplicationStepsInterface, continueLoading: boolean = false) => {
    localStorage.setItem('hasRentableItems', res.HasRentableItems.toString());
    localStorage.setItem('verifastEnabled', res.VerifastEnabled.toString());
    localStorage.setItem('HasAncillaryItems', res.HasAncillaryItems.toString());
    if (res.HasRentableItems || res.HasAncillaryItems) {
      this.hasRentableItems = true;
      this.totalApplicationSteps = 9;
    }
    if (res.VerifastEnabled) {
      this.totalApplicationSteps++;
    }
    if (continueLoading) {
      this.continueLoading()
    }
  }

  setRentalRate(rates: RentalRates) {
    this.rentalRates = rates;

    if(rates?.DayTermOptions) {
      this.setAvailableMoveInDates(rates.DayTermOptions);
    }

    if (this.model.DesiredMoveInDate) {
      let passedDate = this.model.DesiredMoveInDate;

      passedDate.setHours(0, 0, 0, 0);

      if (this.rentalRates.DayTermOptionsMap.has(`${passedDate.getUTCFullYear()}-${passedDate.getUTCMonth()}-${passedDate.getUTCDate()}`)) {
        this.setLeaseTermOptions(this.rentalRates.DayTermOptionsMap.get(`${passedDate.getUTCFullYear()}-${passedDate.getUTCMonth()}-${passedDate.getUTCDate()}`).Terms, this.desiredLeaseTerm);
      } else if(this.rentalRates?.LeaseTerms?.length) {
        this.setLeaseTermOptions(this.rentalRates.LeaseTerms.map(x => x.LeaseTerm), this.desiredLeaseTerm || null);
      }
    } else if(!this.isSFRC && this.rentalRates?.LeaseTerms?.length) {
      this.setLeaseTermOptions(this.rentalRates.LeaseTerms.map(x => x.LeaseTerm), this.desiredLeaseTerm || null);
    }
  }

  setPrimaryFlag(res: boolean) {
    localStorage.setItem('PrimaryApplicant', res.toString());
  }

  setCorrectStatusFlag(res: boolean) {
    if (res == false) {
      localStorage.removeItem('RentalApplicationKey');
      this.analyticsService.track(
        'HRA Application',
        'Basic Information',
        'Stop',
        'Application not in the correct status',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard']);
    }
    else {
      localStorage.setItem('CorrectStatus', res.toString());
    }
  }

  onGetProperties(properties: string[]) {
    this.properties = properties;
    localStorage.setItem('ReferralProperties', JSON.stringify(properties));
  }

  search(event) {
    if (this.properties.length > 0) {
      this.results = this.properties.filter(
        prop => prop.toLowerCase().indexOf(event.query.toLowerCase()) >= 0
      );
    }
  }

  getHasReferralOptions() {
    this.hasReferralOptions = [];
    this.hasReferralOptions.push({ label: "Yes", value: true });
    this.hasReferralOptions.push({ label: "No", value: false });
  }

  getMoveReasons(reasons: MoveInReason[]) {
    this.moveReasons = [];
    for (const reason of reasons) {
      this.moveReasons.push({ label: reason.Title, value: reason.RentalMoveInReasonKey });
    }
  }

  getLeasingAgentOptions(options: LeasingAgent[]) {
    this.leasingAgentOptions = [];

    for (const option of options) {
      this.leasingAgentOptions.push({ label: option.DisplayText, value: option.Value });
    }
  }

  getHasExternalAgentOptions() {
    this.hasExternalAgentOptions = [];
    this.hasExternalAgentOptions.push({ label: "Yes", value: true });
    this.hasExternalAgentOptions.push({ label: "No", value: false });
  }

  setLeaseTermOptions(termOptions: number[], passedTerm: number = null) {
    this.leaseTermOptions = [];

    for (const lOption of termOptions) {
      this.leaseTermOptions.push({ label: lOption + " Months", value: lOption });
    }

    if (passedTerm && termOptions.includes(parseInt(passedTerm.toString()))) {
      this.model.LeaseTerm = Number(passedTerm);
    }

    if (this.model.DesiredMoveInDate && this.model.LeaseTerm) {
      this.updateRentalRate(this.model.DesiredMoveInDate, this.model.LeaseTerm);
    }
  }

  setAvailableMoveInDates(days: RentalRatesDay[]) {
    let minDate = null;
    let maxDate = null;

    for(const day of days) {
      if(!minDate) {
        minDate = day.Date;
      } else if(minDate > day.Date) {
        minDate = day.Date;
      }

      if(!maxDate) {
        maxDate = day.Date;
      } else if(maxDate < day.Date) {
        maxDate = day.Date;
      }
    }

    if(minDate && maxDate) {
      this.minMoveInDate = minDate;
      this.minMoveInDate.setHours(0, 0, 0, 0);

      this.maxMoveInDate = maxDate;
      this.maxMoveInDate.setHours(0, 0, 0, 0);
    }
  }

  getSmartHomeInterestOptions() {
    this.smartHomeInterestOptions = [];
    this.smartHomeInterestOptions.push({ label: "Yes", value: true });
    this.smartHomeInterestOptions.push({ label: "No", value: false });
  }

  async getBasicInfo(applicant: ApplicantBasic) {
    this.model = applicant;

    if (this.desiredMoveInDate) {
      this.model.DesiredMoveInDate = this.desiredMoveInDate;
    }

    this.getMarketingInfo();

    if (this.model.FirstName !== null && this.model.LastName !== null && this.AddAdditionalApplicantKey != null) {
      this.AddAdditionalApplicantName = this.model.FirstName + " " + this.model.LastName;
      localStorage.setItem('AddAdditionalApplicantName', this.AddAdditionalApplicantName);
    }

    let AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');

    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.model.CompletedByOther = true;
    }
    else {
      this.model.CompletedByOther = false;
    }

    //Checks for HRA Invite Token
    let InviteHRA = localStorage.getItem('InviteHRA');

    if (InviteHRA !== null && InviteHRA !== undefined) {
      this.model.InviteHRA = InviteHRA;
    }
    else {
      this.model.InviteHRA = null;
    }

    //Populate lease term options if this applicant already has a desired move in date.
    // if (this.model.DesiredMoveInDate != null) {
    //   this.checkforVariablePricing(localStorage.getItem('YardiKey'));npm ru
    // }

    if (applicant.Email == null || applicant.Email == "") {
      if (this.providerType !== null) {
        if (this.email != null) {
          this.model.Email = this.email;
        }
      } else {
        this.model.Email = this.cognitoUtil.getCurrentUser().getUsername();
      }
    }

    if (this.model.DesiredMoveInDate) {
      this.model.DesiredMoveInDate = new Date(applicant.DesiredMoveInDate);
    }

    if (this.model.HomePhone) {
      const homePhoneTemp = this.model.HomePhone.replace(/[^A-Z0-9]/ig, "");
      this.homePhoneNumber = new TelephoneNumber(homePhoneTemp.substr(0, 3), homePhoneTemp.substr(3, 3), homePhoneTemp.substr(6, 4));
    }

    if (this.model.CellPhone) {
      const cellPhoneTemp = this.model.CellPhone.replace(/[^A-Z0-9]/ig, "");
      this.cellPhoneNumber = new TelephoneNumber(cellPhoneTemp.substr(0, 3), cellPhoneTemp.substr(3, 3), cellPhoneTemp.substr(6, 4));
    }

    if (AddAdditionalApplicantKey === null || AddAdditionalApplicantKey === undefined) {
      window.localStorage.setItem('RentalApplicantKey', applicant.RentalApplicantKey.toString());
    }
    this.checkforVariablePricing(localStorage.getItem('YardiKey'));
  }

  processRentalRates(res: RentalRates) {
    if (res == null) {
      this.errorService.showError(`No rental rates found for the selected property.`);
    } else {
      this.setRentalRate(res);
    }
  }

  getMarketingInfo() {

    let trackingParams = localStorage.getItem('TrackingParameters');

    if (trackingParams) {
      this.trackingParams = JSON.parse(trackingParams);

      this.model.Source = this.trackingParams.Source;
      this.model.Campaign = this.trackingParams.Campaign;
      this.model.AdGroup = this.trackingParams.AdGroup;
      this.model.Medium = this.trackingParams.Medium;
      this.model.Keyword = this.trackingParams.Keyword;
      this.model.AdCopy = this.trackingParams.AdCopy;
      this.model.Device = this.trackingParams.Device;
    }
  }

  cancelEdit() {
    localStorage.removeItem('AddAdditionalApplicantKey');
    localStorage.removeItem('AddAdditionalApplicantName');
    this.analyticsService.track(
      'HRA Application',
      'Basic Information',
      'Stop',
      'Cancelling edit',
      '/application/applicants',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/applicants']);
  }

  selectBestTerm() {
    this.analyticsService.track(
      'HRA Application',
      'Basic Information',
      'Selecting best value',
      'The best value option was selected',
      '/application/landing',
      this.additionalAnalyticsDetails());
    if (this.model.DesiredMoveInDate != this.rentalRates.BestLeaseTermDate) {
      this.onMoveInDateChange(this.rentalRates.BestLeaseTermDate, this.rentalRates.BestLeaseTerm);
    }
    else {
      this.model.LeaseTerm = this.rentalRates.BestLeaseTerm;
    }

    this.displayedRentRate = this.rentalRates.BestLeaseTermRent;
    this.onUpdateRentRateOrRange();
  }

  updateRentalRate(chosenDate: Date = null, chosenTerm: number = null) {
    if (!chosenDate || !chosenTerm) {
      chosenDate = this.model.DesiredMoveInDate;
      chosenTerm = this.model.LeaseTerm;
    }

    let hashKey = `${chosenDate.getUTCFullYear()}-${chosenDate.getUTCMonth()}-${chosenDate.getUTCDate()}-${chosenTerm}`;
    if (this.rentalRates.DayTermRentMap.has(hashKey)) {
      this.displayedRentRate = this.rentalRates.DayTermRentMap.get(hashKey);
      this.onUpdateRentRateOrRange();
    }
  }

  pricingCalendarClick() {
    this.analyticsService.track(
      'HRA Application',
      'Basic Information',
      'Pricing calendar open',
      'The pricing calendar was opened',
      '',
      this.additionalAnalyticsDetails());
    const minFactorWidth: number = 0.75;
    const minFactorHeight: number = 0.85;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = (window.innerWidth * minFactorWidth) + "px";
    dialogConfig.height = (window.innerHeight * minFactorHeight) + "px";
    dialogConfig.maxWidth = window.innerWidth + "px";
    dialogConfig.maxHeight = window.innerHeight + "px";

    dialogConfig.data = {
      dayTermRentMap: this.rentalRates.DayTermRentMap,
      leaseTerm: this.model.LeaseTerm,
      desiredMoveInDate: this.model.DesiredMoveInDate,
      leaseTermOptions: this.rentalRates.LeaseTermOptions,
    };
    
    let dialogRef = this.dialog.open(PricingCalendarComponent, dialogConfig);
    dialogRef.componentInstance.onDateSelect.subscribe(data => {
      this.onMoveInDateChange(data[0], data[1]);
      this.displayedRentRate = data[2];
      this.onUpdateRentRateOrRange();
      this.analyticsService.track(
        'HRA Application',
        'Basic Information',
        'Pricing calendar close',
        'Move in date was changed',
        '',
        this.additionalAnalyticsDetails());
    });

  }

  onSubmit() {
    this.disableSubmitBtn = true;
    //Clears info if No is selected
    if (this.model.hasReferrals == false) {
      this.model.ReferralName = null;
    }

    this.model.HomePhone = this.homePhoneNumber?.format() ?? "";
    this.model.CellPhone = this.cellPhoneNumber?.format() ?? "";

    if (this.displayedRentRate) {
      this.model.RentalRateRent = this.displayedRentRate;
    }

    localStorage.removeItem('DesiredMoveInDate');
    localStorage.removeItem('DesiredLeaseTerm');

    this.applicationService.updateBasicInformation(this.model)
      .subscribe(res => this.onUpdateSuccess(res),
        res => {
          this.disableSubmitBtn = false;
          this.errorMessage = this.applicationService.handleError(res)
          });
  }

  onMoveInDateChange(date: any, passedTerm: number = null) {

    if (date) {
      if (date.value) {
        this.model.DesiredMoveInDate = new Date(date.value);
      }
      else {
        this.model.DesiredMoveInDate = new Date(date);
      }

      if (this.rentalRates.DayTermOptionsMap.has(`${this.model.DesiredMoveInDate.getUTCFullYear()}-${this.model.DesiredMoveInDate.getUTCMonth()}-${this.model.DesiredMoveInDate.getUTCDate()}`)) {
          this.setLeaseTermOptions(this.rentalRates.DayTermOptionsMap.get(`${this.model.DesiredMoveInDate.getUTCFullYear()}-${this.model.DesiredMoveInDate.getUTCMonth()}-${this.model.DesiredMoveInDate.getUTCDate()}`).Terms, passedTerm);
      }
    }
  }

  onUpdateSuccess(basicInfo: ApplicantBasic) {
    localStorage.removeItem('InviteHRA');
    let AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    if (AddAdditionalApplicantKey === null || AddAdditionalApplicantKey === undefined) {
      localStorage.setItem('RentalApplicantKey', basicInfo.RentalApplicantKey.toString());
    }
    if (basicInfo.IsWaitListed) {
      this.analyticsService.track(
        'HRA Application',
        'Basic Information',
        'Stop',
        'Application is waitlisted',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard', 'waitlist']);
    } else {
      this.analyticsService.track(
        'HRA Application',
        'Basic Information',
        'Stop',
        'Sending to personal',
        '/application/personal',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/personal'], { fragment: 'personalinfo' });
    }
  }

  onUpdateRentRateOrRange(): void {
    this.displayedRentRateOrRange = this.modelProperty?.rent || `${this.displayedRentRate}`;
  }

}
